<template>
  <div class="homepage-grid">
    <div>
      <SS23Hero
        video-url="https://cdn.shopify.com/videos/c/o/v/e5d5552a73ee4150b6806f64ea8a6827.mp4"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/homepage-video.jpg?v=1686476233',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/homepage-video.jpg?v=1686476233',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/ezgif-frame-001_dfcb842d-7204-4b38-b5af-5cd8e60dae2a.jpg?v=1686476237',
        }"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/a-state-of-bliss">
            Discover New Arrivals
          </Button>
        </template>
      </SS23Hero>
    </div>
    <div>
      <SS23MediaCard
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/dresse-medium.jpg',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/dresse-medium.jpg',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/dresses-large.jpg',
        }"
        link="/collections/dresses"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/dresses">
            Dresses
          </Button>
        </template>
      </SS23MediaCard>
    </div>
    <div>
      <SS23MediaCard
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/beachwear-large.jpg?v=1685640450',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/beachwear-large.jpg?v=1685640450',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/beachwear-large.jpg?v=1685640450',
        }"
        link="/collections/beachwear"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/beachwear">
            Beachwear
          </Button>
        </template>
      </SS23MediaCard>
    </div>
    <div>
      <FeaturedCollectionCarousel
        collection-handle="a-state-of-bliss"
        flat-lays
      />
    </div>
    <div>
      <SS23MediaCard
        title="Members Only"
        align-title="top"
        text="Your access-all-areas pass to our V.I.P world of unique rewards and bespoke benefits"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/member-only-medium.jpg',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/member-only-medium.jpg',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/members-only-large.jpg?v=1685640450',
        }"
      >
        <template #cta>
          <Button transparent @click="setSlideLogin(true)">Sign In</Button>
          <Button transparent @click="setSlideSignUp(true)"
            >Create Account</Button
          >
        </template>
      </SS23MediaCard>
    </div>
    <div>
      <SS23MediaCard
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/holiday-capsule-small_443477af-5880-440c-aa0b-a8acbf45dbb4.jpg?v=1686233310',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/holiday-capsule-medium_d7b1a387-dec9-42b1-b1c7-19bc2bb22244.jpg?v=1686233310',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/holiday-capsule-large_1356afc5-a577-4122-91dc-e7f5f7d6959f.jpg?v=1686233310',
        }"
        link="/collections/holiday-capsule"
        text="The dusk-till-dawn dresses and stand-out swimwear made for flawless summer style wherever you're escaping to"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/holiday-capsule">
            The Holiday Capsule
          </Button>
        </template>
      </SS23MediaCard>
    </div>
    <div>
      <SS23MediaCard
        title="The Journal"
        align-title="middle"
        text="Be inspired by our insider travel guides, get expert styling advice and meet our most-loved tastemakers and muses"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/journal-small.jpg?v=1685640450',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/journal-medium.jpg?v=1685640450',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/journal-large.jpg?v=1685640450',
        }"
        video-url="https://cdn.shopify.com/videos/c/o/v/62adfaa71abe4ac29d0c4cb1b9bae1bc.mp4"
      >
        <template #cta>
          <Button transparent tag="a" href="/blogs/journal">
            Read our stories
          </Button>
        </template>
      </SS23MediaCard>
    </div>
    <div>
      <template v-if="mq.mdPlus">
        <SS23MediaCard
          title="Occasion Dressing"
          text="Elevate your style with dresses made for elegant events, evening soirees and special occasions all year round"
          :images="{
            smallMedia:
              'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/event-dressing-large_4436154c-9376-4c01-80c9-5c6d83aab3ec.jpg?v=1686233244',
            mediumMedia:
              'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/event-dressing-large_4436154c-9376-4c01-80c9-5c6d83aab3ec.jpg?v=1686233244',
            largeMedia:
              'https://cdn.shopify.com/s/files/1/0942/9062/files/event-dressing-large.jpg?v=1685640450',
          }"
        >
          <template #cta>
            <Button transparent tag="a" href="/collections/occasion-dressing">
              Shop Now
            </Button>
          </template>
        </SS23MediaCard>
      </template>
      <template v-else>
        <SS23MediaCard
          :images="{
            smallMedia:
              'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/event-dressing-large_4436154c-9376-4c01-80c9-5c6d83aab3ec.jpg?v=1686233244',
            mediumMedia:
              'https://cdn.shopify.com/s/files/1/0609/8124/8218/files/event-dressing-large_4436154c-9376-4c01-80c9-5c6d83aab3ec.jpg?v=1686233244',
            largeMedia:
              'https://cdn.shopify.com/s/files/1/0942/9062/files/event-dressing-large.jpg?v=1685640450',
          }"
        >
          <template #cta>
            <Button transparent tag="a" href="/collections/event-dressing">
              Event Dressing
            </Button>
          </template>
        </SS23MediaCard>
      </template>
    </div>
    <div>
      <SS23MediaCard
        title="SIGN UP TO OUR NEWSLETTER"
        video-url="https://cdn.shopify.com/videos/c/o/v/eaa4e6fa1cab4b5db6f6246eef187761.mp4"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/newsletter-small.jpg?v=1685640450',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/newsletter-medium.jpg?v=1685640450',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/newsletter-large.jpg?v=1685640450',
        }"
        link="/pages/members"
      />
    </div>
  </div>
</template>

<script>
import SS23MediaCard from "@/components/homepage/SS23MediaCard.vue";
import SS23Hero from "@/components/homepage/SS23Hero.vue";
import FeaturedCollectionCarousel from "@/components/FeaturedCollectionCarouselV2.vue";
import Button from "@/components/Button.vue";
import { mapActions } from "vuex";
export default {
  name: "HomePage",
  components: {
    SS23Hero,
    SS23MediaCard,
    FeaturedCollectionCarousel,
    Button,
  },
  inject: ["mq"],
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.homepage-grid {
  @include respond-above(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }

  & > div {
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }

    @include respond-above(md) {
      margin-bottom: 0;

      &:nth-child(1),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(8),
      &:nth-child(9) {
        grid-column: 1 / 3;
      }
    }
  }
}
</style>
